import {
  useFormCategoriesSearchListLazyQuery,
  useTasksSearchListLazyQuery,
} from 'graphql-common';
import { useEdmDocumentationsLazyQuery } from '@lib/graphql-common';
import { getFormCategoriesLoadOptions as getFormCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/formCategoriesSearchList';
import { getTasksLoadOptions as getTasksLoadOptionsFn } from 'utils/fetch/searchLists/tasksSearchList';
import { getDocumentationsLoadOptions as getDocumentationsLoadOptionsFn } from 'utils/fetch/searchLists/documentationsSearchList';
import { GetLoadOptions } from '@lib/components/Select/types';

interface Props {
  id: string;
}

export default function useSearchListQueries(props: Props) {
  const { id } = props;

  // Form category
  const [fetchFormCategoriesLazyQuery] = useFormCategoriesSearchListLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const getFormCategoriesLoadOptions: GetLoadOptions = () =>
    getFormCategoriesLoadOptionsFn(fetchFormCategoriesLazyQuery);

  const [fetchTasksLazyQuery] = useTasksSearchListLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const getTasksLoadOptions: GetLoadOptions = () =>
    getTasksLoadOptionsFn({
      fetchLazyQuery: fetchTasksLazyQuery,
      scope: {
        custom: {
          linkedToFormTemplateGrouped: { templateId: id },
        },
      },
      selectedSiteIds: [],
    });

  // Documentations
  const [fetchDocumentationsLazyQuery] = useEdmDocumentationsLazyQuery({
    fetchPolicy: 'cache-and-network',
  });
  const getDocumentationsLoadOptions: GetLoadOptions = () =>
    getDocumentationsLoadOptionsFn(fetchDocumentationsLazyQuery);

  return {
    getFormCategoriesLoadOptions,
    getDocumentationsLoadOptions,
    getTasksLoadOptions,
  };
}
